import http from '../../../utils/fetch';
import updownfile from '../../../utils/updownfile';
export default {
    //oem库存明细主列表
    selectPage(v) {
        return http({
            url: '/api/swyl/v1/report/oemStock/selectPage',
            method: 'post',
            params: v
        });
    },
    //查询占用列表分页
    selectOccupyPage(v) {
        return http({
            url: '/api/swyl/v1/report/oemStock/selectOccupyPage',
            method: 'post',
            params: v
        });
    },
    //查询在途列表分页
    selectRoadPage(v) {
        return http({
            url: '/api/swyl/v1/report/oemStock/selectRoadPage',
            method: 'post',
            params: v
        });
    },
    //查询订单量分页
    selectOrderPage(v) {
        return http({
            url: '/api/swyl/v1/report/oemStock/selectOrderPage',
            method: 'post',
            params: v
        });
    },
    ///api/swyl/v1/report/oemStock/downloadRoadExcel在途量导出
    downloadRoadExcel(c){
        updownfile.down('/api/swyl/v1/report/oemStock/downloadRoadExcel',c,"post",'data');
        //window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCompetitorsForExcel?companyName='+companyName+'&cdate='+cdate
    },

    ///api/swyl/v1/report/oemStock/downloadOrderExcel订单量导出
    downloadOrderExcel(c){
        updownfile.down('/api/swyl/v1/report/oemStock/downloadOrderExcel',c,"post",'data');
        //window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCompetitorsForExcel?companyName='+companyName+'&cdate='+cdate
    },
}